/**
 * Deeply merges project defaults with customer panel settings.
 * Priority: panelSettings > projectDefaults.
 *
 * @param {Object|null} params
 * @param {Object|null} params.projectConfig
 * @param {Object|null} params.panelSettings
 * @returns {Object} Effective combined settings object
 */
export function resolveEffectiveSettings({projectConfig, panelSettings}) {
  const defaults = projectConfig?.settings_defaults ?? {}
  const overrides = panelSettings ?? {}

  if (!panelSettings) return defaults

  const merged = { ...defaults, ...overrides }

  for (const key of Object.keys(defaults)) {
    if (
      defaults[key] &&
      typeof defaults[key] === 'object' &&
      !Array.isArray(defaults[key]) &&
      overrides[key] &&
      typeof overrides[key] === 'object' &&
      !Array.isArray(overrides[key])
    ) {
      merged[key] = { ...defaults[key], ...overrides[key] }
    }
  }

  return merged
}